<template>
  <div>
    <!-- Header -->
    <div class="header bg-gradient-success py-7 py-lg-8 pt-lg-9">
      <b-container class="container">
        <div class="header-body text-center mb-7">
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <b-container class="mt--80 pb-5">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" >
          <b-card no-body class="bg-secondary border-0">
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-muted mb-4">
                <h2>Регистрация</h2>
              </div>
              <validation-observer v-slot="{handleSubmit}" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-hat-3"
                              placeholder="Имя"
                              name="Name"
                              :rules="{required: true}"
                              v-model="model.name">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-email-83"
                              placeholder="Почта"
                              name="Email"
                              :rules="{required: true, email: true}"
                              v-model="model.email">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Пароль"
                              type="password"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              v-model="model.password">
                  </base-input>

                  <base-input alternative
                              class="mb-3"
                              prepend-icon="ni ni-lock-circle-open"
                              placeholder="Подтверждение пароля"
                              type="password"
                              name="Password"
                              :rules="{required: true, min: 6}"
                              v-model="model.password_confirm">
                  </base-input>

                  <div class="text-right">
                    <b-button type="submit"  variant="primary"  class="register_btn mt-4 vs-con-loading__container">Создать аккаунт <span v-show="loading" id="loading-container"></span></b-button>
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios'
  export default {
    name: 'register',
    data() {
      return {
        loading: false,
        backgroundLoading: 'transparent',
        colorLoading: '#fff',
        model: {
          name: '',
          email: '',
          password: '',
          password_confirm: ''
        }
      }
    },
    methods: {
      async onSubmit() {
        // this will be called only after form is valid. You can do an api call here to register users
        this.loading = true
        this.$vs.loading({
          background: this.backgroundLoading,
          color: this.colorLoading,
          container: '#loading-container',
          scale: 0.45
        })
        const response = await axios
        .post("register", {
          name: this.model.name,
          email: this.model.email,
          password: this.model.password,
          password_confirmation: this.model.password_confirm
        }).finally(() => this.loading = false, this.$vs.loading.close('#loading-container > .con-vs-loading'));

        localStorage.setItem("token", response.data.token);
        const token = localStorage.getItem('token');
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.$store.dispatch("fetchUser");
        // this.$router.go(this.$router.currentRoute);
        setTimeout(() => {
          this.$router.push({ name: 'dashboard' });
        }, 100);

      }
    }

  };
</script>

<style scoped>
#loading-container {
  width: 15px;
  margin-left: 10px;
  display: inherit;
  position: relative;
  bottom: 5px
}
h2 {
  font-size: 24px;
  color: #32325d;
}
.mt--80 {
  margin-top: -14rem;
}
@media only screen and (max-width: 600px) {
  .mt--80 {
    margin-top: -12rem;
  }
}
</style>
